/* eslint-disable no-unused-vars */
import React from 'react';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { ImageWithFallback, ParagraphWithTooltip } from 'components';
import { subdirectory } from 'utils';

export const DropDownItem = ({
  pba_number,
  apps,
  imageUrl,
  searchValue,
  appNumberIsSelected,
  toggleSelectedAppNumber,
  package: packageName,
}) => {
  return (
    <Box
      key={pba_number}
      isSelected={appNumberIsSelected(pba_number)}
      onClick={() => toggleSelectedAppNumber(pba_number)}
    >
      <AppIcon>
        <ImageWithFallback src={`https://cdn.appnext.com/${subdirectory(imageUrl)}/${imageUrl}`} />
      </AppIcon>
      <div
        style={{
          width: '82%',
          height: '100%',
          display: 'flex',
          gap: '3px',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <ParagraphWithTooltip
          text={`${apps}`}
          style={{ fontSize: '14px', fontWeight: '400' }}
          search={searchValue}
          isHighlight
          highlightStyle={{ color: `${Palette.Primary._900}`, fontWeight: '700' }}
        />

        {packageName && (
          <ParagraphWithTooltip
            text={packageName ?? ''}
            style={{ fontSize: '12px', fontWeight: '400', color: Palette.PrimaryGray._500 }}
            search={searchValue}
            isHighlight
            highlightStyle={{ color: `${Palette.Primary._900}`, fontWeight: '700' }}
          />
        )}
        <ParagraphWithTooltip
          text={`ID:${pba_number.toString()}`}
          style={{ fontSize: '12px', fontWeight: '400', color: Palette.PrimaryGray._700 }}
          search={searchValue}
          isHighlight
          highlightStyle={{ color: `${Palette.Primary._900}`, fontWeight: '700' }}
        />
      </div>
    </Box>
  );
};

const Box = styled.div`
  height: 74px;
  height: auto;
  cursor: pointer;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid white;
  &:hover {
    background: ${Palette.PrimaryGray._100};
  }
  ${({ isSelected }) => {
    return (
      isSelected &&
      css`
        background: ${Palette.PrimaryGray._100};
        border: 1px solid ${Palette.Primary._300};
      `
    );
  }}
`;
const AppIcon = styled.div`
  width: 36px;
  height: 36px;
  display: block !important;
  img {
    display: block !important;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
`;
